import { useNavigate, useParams } from "react-router-dom";
import { uploadMentionsHref } from "@/features/mentions/upload-mentions-link";
import { UploadDetailPage } from "@/features/uploads/UploadDetailPage";
import { useAppShell } from "@/shell/app-shell-context";
import { ApiState } from "@/shared/components/ApiState";
import { useRequireCompany } from "@/shared/hooks/useRequireCompany";
import { hasRoleAtLeast } from "@/shared/utils/roles";

export function UploadDetailRoute() {
  const navigate = useNavigate();
  const { uploadId } = useParams();
  const { token, profile } = useAppShell();
  const company = useRequireCompany();

  if (!company) return null;
  // Mesmo papel que a API exige pra enviar e corrigir uploads (2026-10-24).
  if (!hasRoleAtLeast(profile, "technician")) {
    return <ApiState kind="error">Os uploads são de Técnico ou acima.</ApiState>;
  }

  const parsedId = Number(uploadId);
  // Id não-numérico na URL nem chega na API — a página trata como o
  // mesmo "não encontrado" que um id de outra empresa produziria.
  const safeId = Number.isInteger(parsedId) ? parsedId : -1;
  return (
    <UploadDetailPage
      token={token}
      uploadId={safeId}
      backHref={`/empresas/${company.id}/uploads`}
      mentionsHref={uploadMentionsHref(company.id, safeId)}
      onOpenDownloads={() => navigate(`/empresas/${company.id}/downloads`)}
      settingsTabHref={(tab, params) => {
        // `params` leva o nome (e a marca, e a fonte) que a planilha
        // trouxe, pro cadastro abrir o formulário já preenchido.
        const query = new URLSearchParams({ tab, ...params });
        return `/empresas/${company.id}/configuracoes?${query.toString()}`;
      }}
    />
  );
}
